export const getDashboardState = () => {
  // eslint-disable-next-line prefer-const
  let state = null
  if (typeof window !== 'undefined') {
    state = JSON.parse(window.sessionStorage.getItem('state'))
    if (!state) {
      state = JSON.parse(window.localStorage.getItem('state'))
    }
  }
  return state
}
